import React from 'react';
import { Link } from 'react-router-dom';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiPhone, FiMail, FiMapPin, FiSettings, FiTool } = FiIcons;

const Footer = () => {
  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Company Info */}
          <div className="col-span-1 md:col-span-2">
            <div className="flex items-center space-x-3 mb-4">
              <div className="relative">
                <div className="w-10 h-10 bg-blue-800 rounded-lg flex items-center justify-center">
                  <SafeIcon icon={FiSettings} className="text-xl text-white" />
                </div>
                <div className="absolute -bottom-1 -right-1 w-5 h-5 bg-orange-500 rounded-full flex items-center justify-center">
                  <SafeIcon icon={FiTool} className="text-xs text-white" />
                </div>
              </div>
              <div>
                <h3 className="text-lg font-bold">Gauteng Manufacturing Co.</h3>
                <p className="text-sm text-gray-400">Precision Manufacturing Excellence Since 1985</p>
              </div>
            </div>
            <p className="text-gray-300 mb-4">
              Four decades of South African industrial excellence, producing world-class components 
              and assemblies for mining, automotive, and infrastructure sectors.
            </p>
            <div className="space-y-2">
              <div className="flex items-center space-x-2">
                <SafeIcon icon={FiMapPin} className="text-orange-500" />
                <span className="text-sm">Germiston & Vanderbijlpark, Gauteng</span>
              </div>
              <div className="flex items-center space-x-2">
                <SafeIcon icon={FiPhone} className="text-orange-500" />
                <span className="text-sm">+27 11 123 4567</span>
              </div>
              <div className="flex items-center space-x-2">
                <SafeIcon icon={FiMail} className="text-orange-500" />
                <span className="text-sm">info@gautengmanufacturing.co.za</span>
              </div>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Quick Links</h4>
            <ul className="space-y-2">
              <li><Link to="/about" className="text-gray-300 hover:text-white transition-colors">About Us</Link></li>
              <li><Link to="/services" className="text-gray-300 hover:text-white transition-colors">Services</Link></li>
              <li><Link to="/blog" className="text-gray-300 hover:text-white transition-colors">Blog</Link></li>
              <li><Link to="/contact" className="text-gray-300 hover:text-white transition-colors">Contact</Link></li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Services</h4>
            <ul className="space-y-2 text-sm">
              <li className="text-gray-300">Heavy Engineering</li>
              <li className="text-gray-300">Precision Machining</li>
              <li className="text-gray-300">CNC Operations</li>
              <li className="text-gray-300">Industrial Automation</li>
              <li className="text-gray-300">Quality Assurance</li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-8 pt-8 flex flex-col md:flex-row justify-between items-center">
          <p className="text-gray-400 text-sm">
            © 2024 Gauteng Manufacturing Co. All rights reserved.
          </p>
          <div className="flex space-x-6 mt-4 md:mt-0">
            <span className="text-gray-400 text-sm">ISO 9001:2015 Certified</span>
            <span className="text-gray-400 text-sm">SANS Compliant</span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;